// src/App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { puedeVerCostosFront } from "./helpers/permisosCostos";
import jwt_decode from "jwt-decode";
import Layout from "./components/Layout";
import "./css/app-theme.css";

//  — Páginas
import UsuariosAdmin        from "./components/UsuariosAdmin";
import CambiarPassword      from "./components/CambiarPassword";
import Home                 from "./pages/Home";
import AcercaDe             from "./pages/AcercaDe";
import HomeImpresion        from "./pages/HomeImpresion";
import HomeAltas            from "./pages/HomeAltas";
import HomeComisiones       from "./pages/HomeComisiones";
import Login                from "./pages/Login";
import Admin                from "./pages/Admin";
import Clientes             from "./pages/Clientes";
import ClientesRecepcion    from "./pages/ClientesRecepcion";
import Financieras          from "./pages/Financieras";
import Turnos               from "./pages/Turnos";
import Proveedores          from "./pages/Proveedores";
import Comandas             from "./pages/Comandas";
import Transportes          from "./pages/Transportes";
import Choferes             from "./pages/Choferes";
import Camiones             from "./pages/Camiones";
import Estaciones           from "./pages/Estaciones";
import Productos            from "./pages/Productos";
import Localidades          from "./pages/Localidades";
import Provincias           from "./pages/Provincias";
import Deptos               from "./pages/Deptos";
import Empresas             from "./pages/Empresas";
import Destinos             from "./pages/Destinos";
import Estados              from "./pages/Estados";
import Observas             from "./pages/Observas";
import Gastos               from "./pages/Gastos";
import Imputas              from "./pages/Imputas";
import Metodos              from "./pages/Metodos";
import Movs                 from "./pages/Movs";
import Tipos                from "./pages/Tipos";
import Viajes               from "./pages/Viajes";
import Remitos              from "./pages/Remitos";
import Remitocs             from "./pages/Remitocs";
import Cajas                from "./pages/Cajas";
import Lotes                from "./pages/Lotes";
import Personas             from "./pages/Personas";
import Colores              from "./pages/Colores";
import Marcas               from "./pages/Marcas";
import Ventas               from "./pages/Ventas";
import VentaRapida          from "./pages/VentaRapida";
import CategoriasProductos  from "./pages/CategoriasProductos";
import AdministracionFinancieras from "./components/AdministracionFinancieras";
import AdministradorComisiones   from "./components/AdministradorComisiones";
import FinancierasVigentes       from "./components/FinancierasVigentes";
import InformeRentabilidadVentas from "./pages/InformeRentabilidadVentas";
import InformeComandas          from "./pages/InformeComandas";
import InformeProductos         from "./pages/InformeProductos";
import InformeRemitos           from "./pages/InformeRemitos";
import InformeRemitocs          from "./pages/InformeRemitocs";
import InformeCajas             from "./pages/InformeCajas";
import InformeMovimientos       from "./pages/InformeMovimientos";
import InformeTurnos            from "./pages/InformeTurnos";
import InformeMovs              from "./pages/InformeMovs";
import InformeClientes          from "./pages/InformeClientes";
import InformeClientesRecepcion from "./pages/InformeClientesRecepcion";
import InformeRendiciones       from "./pages/InformeRendiciones";
import InformeOrdenCobro        from "./pages/InformeOrdenCobro";
import InformeOrdenPago         from "./pages/InformeOrdenPago";
import InformeCartera           from "./pages/InformeCartera";
import InformeTesoreria         from "./pages/InformeTesoreria";
import InformeCliPro            from "./pages/InformeCliPro";
import InformeVentas            from "./pages/InformeVentas";
import InformeVentasAnuladas    from "./pages/InformeVentasAnuladas";
import InformePedidos           from "./pages/InformePedidos";
import InformePedidosAgrupado   from "./pages/InformePedidosAgrupado";
import InformeOrganizarPedidos  from "./pages/InformeOrganizarPedidos";
import InformeOrdenesPedido     from "./pages/InformeOrdenesPedido";
import InformeProductos1        from "./pages/InformeProductos1";
import InformeFinancieroVentas  from "./pages/InformeFinancieroVentas";
import InformeSeguimientosClientes from "./pages/InformeSeguimientosClientes";
import InformeDashboardFinanciero  from "./pages/InformeDashboardFinanciero";
import InformeVendedoresVentas     from "./pages/InformeVendedoresVentas";
import DashboardControlRiders      from "./pages/DashboardControlRiders";
import InformeAuditoria            from "./pages/InformeAuditoria";
import DashboardAuditoria          from "./pages/DashboardAuditoria";
import InformeComisionesLiquidaciones from "./pages/InformeComisionesLiquidaciones";
import InformeComisionesPagos         from "./pages/InformeComisionesPagos";
import InformeComisionesSaldos        from "./pages/InformeComisionesSaldos";
import InformeComisionesVendedores    from "./pages/InformeComisionesVendedores";
import InformeComisionesDetalle       from "./pages/InformeComisionesDetalle";

const isLoggedIn = () => !!localStorage.getItem("token");

const getUsuarioToken = () => {
  const token = localStorage.getItem("token") || "";

  try {
    if (!token) return null;

    const decoded = jwt_decode(token);
    return decoded?.usuario || decoded?.user || decoded || null;
  } catch {
    return null;
  }
};

const getRole = () => {
  const usuario = getUsuarioToken();
  return usuario?.role || "";
};

const getHomeByRole = () => {
  const role = getRole();

  if (role === "VENDEDOR_ROLE") {
    return "/Home";
  }

  if (role === "MANAGER_ROLE") {
    return "/Ventas";
  }

  return "/";
};

const puedeEntrar = (roles = []) => {
  if (!roles || roles.length === 0) return true;

  const role = getRole();

  if (["ROOT_ROLE", "ADMIN_ROLE"].includes(role)) return true;

  return roles.includes(role);
};

const PrivateRoute = ({ component: Component, roles = [], ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isLoggedIn()) {
        return <Redirect to="/login" />;
      }

      const usuario = getUsuarioToken();

      const esCambioPassword =
        rest.path === "/cambiar-password";

      if (
        usuario?.debeCambiarPassword &&
        !esCambioPassword
      ) {
        return (
          <Redirect to="/cambiar-password" />
        );
      }

      if (!puedeEntrar(roles)) {
        return <Redirect to={getHomeByRole()} />;
      }

      return <Component {...props} />;
    }}
  />


);

const PrivateCostRoute = ({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isLoggedIn()) {
        return <Redirect to="/login" />;
      }

      const usuario = getUsuarioToken();

      const esCambioPassword =
        rest.path === "/cambiar-password";

      if (
        usuario?.debeCambiarPassword &&
        !esCambioPassword
      ) {
        return (
          <Redirect to="/cambiar-password" />
        );
      }

      /*
        Esta pantalla contiene información sensible:
        costos y rentabilidad.

        Solo ROOT_ROLE / ADMIN_ROLE autorizados.
        Respeta también puedeVerCostos:false.
      */
      if (!puedeVerCostosFront()) {
        return (
          <Redirect to={getHomeByRole()} />
        );
      }

      return <Component {...props} />;
    }}
  />
);

const HomePorRol = (props) => {
  const role = getRole();

  if (
    role === "VENDEDOR_ROLE" ||
    role === "MANAGER_ROLE"
  ) {
    return <Redirect to="/Ventas" />;
  }

  return <Home {...props} />;
};

export default function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          {/* público */}
          <Route exact path="/login" component={Login} />

          {/* privadas */}
          <PrivateRoute
            exact
            path="/cambiar-password"
            component={CambiarPassword}
          />

          <PrivateRoute
            exact
            path="/usuarios-admin"
            component={UsuariosAdmin}
            roles={["ROOT_ROLE"]}
          />
          <PrivateRoute exact path="/Home" component={Home} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/HomeAltas" component={HomeAltas} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/HomeComisiones" component={HomeComisiones} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />
          <PrivateRoute exact path="/HomeImpresion" component={HomeImpresion} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/" component={HomePorRol} />
          <PrivateRoute exact path="/AcercaDe" component={AcercaDe} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/Clientes" component={Clientes} roles={["ADMIN_ROLE", "MANAGER_ROLE","VENDEDOR_ROLE"]}/>
          <PrivateRoute exact path="/ClientesRecepcion" component={ClientesRecepcion} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/Financieras" component={Financieras} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/administracion-financieras" component={AdministracionFinancieras} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/administrador-comisiones" component={AdministradorComisiones} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Turnos" component={Turnos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Proveedores" component={Proveedores} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Comandas" component={Comandas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Empresas" component={Empresas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Destinos" component={Destinos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Estados" component={Estados} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Observas" component={Observas} roles={["ADMIN_ROLE"]} />        
          <PrivateRoute exact path="/Gastos" component={Gastos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Imputas" component={Imputas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Metodos" component={Metodos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Transportes" component={Transportes} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Localidades" component={Localidades} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Provincias" component={Provincias} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Deptos" component={Deptos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Choferes" component={Choferes} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Camiones" component={Camiones} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Estaciones" component={Estaciones} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Productos" component={Productos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Ventas" component={Ventas} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/ventarapida" component={VentaRapida} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/Movs" component={Movs} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Tipos" component={Tipos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Cajas" component={Cajas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Lotes" component={Lotes} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Personas" component={Personas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Viajes" component={Viajes} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Remitos" component={Remitos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Remitocs" component={Remitocs} roles={["ADMIN_ROLE"]}  />
          <PrivateRoute exact path="/Colores" component={Colores} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/Marcas" component={Marcas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/categorias-productos" component={CategoriasProductos} roles={["ADMIN_ROLE"]}  />
          <PrivateRoute exact path="/financieras-vigentes" component={FinancierasVigentes} roles={["ADMIN_ROLE","MANAGER_ROLE","VENDEDOR_ROLE"]}
/>
          {/* informes (en minúscula para coincidir con navbar actualizado) */}
          <PrivateRoute exact path="/informecomandas" component={InformeComandas} roles={["ADMIN_ROLE"]}  />
          <PrivateRoute exact path="/informeproductos" component={InformeProductos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeremitos" component={InformeRemitos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeremitocs" component={InformeRemitocs} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informecajas" component={InformeCajas} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informemovimientos" component={InformeMovimientos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeturnos" component={InformeTurnos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informemovs" component={InformeMovs} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeclientes" component={InformeClientes} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]}  />
          <PrivateRoute exact path="/informeclientesrecepcion" component={InformeClientesRecepcion} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/informerendiciones" component={InformeRendiciones} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeordencobro" component={InformeOrdenCobro} roles={["ADMIN_ROLE"]} />  
          <PrivateRoute exact path="/informeordenpago" component={InformeOrdenPago} roles={["ADMIN_ROLE"]} /> 
          <PrivateRoute exact path="/informecartera" component={InformeCartera} roles={["ADMIN_ROLE"]} /> 
          <PrivateRoute exact path="/informetesoreria" component={InformeTesoreria} roles={["ADMIN_ROLE"]} />       
          <PrivateRoute exact path="/informeclipro" component={InformeCliPro} roles={["ADMIN_ROLE"]} />        
          <PrivateRoute exact path="/informeventas" component={InformeVentas} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />  
          <PrivateRoute exact path="/informeventasanuladas" component={InformeVentasAnuladas} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} /> 
          <PrivateRoute exact path="/informepedidos" component={InformePedidos} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informepedidosagrupado" component={InformePedidosAgrupado} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeorganizarpedidos" component={InformeOrganizarPedidos} roles={["ADMIN_ROLE"]} /> 
          <PrivateRoute exact path="/informeordenespedido" component={InformeOrdenesPedido} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informeproductos1" component={InformeProductos1} roles={["ADMIN_ROLE"]} /> 
          <PrivateCostRoute exact path="/informerentabilidad" component={InformeRentabilidadVentas}/>
          <PrivateRoute exact path="/informefinancieroventas" component={InformeFinancieroVentas} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />  
          <PrivateRoute exact path="/informeseguimientosclientes" component={InformeSeguimientosClientes} roles={["ADMIN_ROLE" , "MANAGER_ROLE"]} />  
          
          <PrivateRoute exact path="/informedashboardfinanciero" component={InformeDashboardFinanciero} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />  
          <PrivateRoute exact path="/informevendedoresventas" component={InformeVendedoresVentas} roles={["ADMIN_ROLE", "MANAGER_ROLE"]} />  
          <PrivateRoute exact path="/informecontrolriders" component={DashboardControlRiders} roles={["ADMIN_ROLE"]} />

          {/* Comisiones */}
          <PrivateRoute exact path="/informe-comisiones-liquidaciones" component={InformeComisionesLiquidaciones} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informe-comisiones-pagos" component={InformeComisionesPagos} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informe-comisiones-saldos" component={InformeComisionesSaldos} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informe-comisiones-vendedores" component={InformeComisionesVendedores} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />
          <PrivateRoute exact path="/informe-comisiones-detalle" component={InformeComisionesDetalle} roles={["ROOT_ROLE", "ADMIN_ROLE"]} />

          {/* Auditoría */}
          <PrivateRoute exact path="/informeauditoria" component={InformeAuditoria} roles={["ADMIN_ROLE"]} />
          <PrivateRoute exact path="/dashboardauditoria" component={DashboardAuditoria} roles={["ADMIN_ROLE"]} />

          {/* admin extra */}
          <PrivateRoute exact path="/admin" component={Admin} roles={["ADMIN_ROLE"]} />

          <PrivateRoute exact path="/clientes" component={Clientes} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/clientesrecepcion" component={ClientesRecepcion} roles={["ADMIN_ROLE", "VENDEDOR_ROLE"]} />
          <PrivateRoute exact path="/ventas" component={Ventas} roles={["ADMIN_ROLE", "MANAGER_ROLE", "VENDEDOR_ROLE"]} />

          {/* catch-all */}
          <Route path="*">
            {isLoggedIn() ? <Redirect to="/" /> : <Redirect to="/login" />}
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
}
